import { __decorate } from "tslib";
import { Component, ViewEncapsulation, } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { Router } from '@angular/router';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Modal Component
 */
let VerifyCourierModalComponent = class VerifyCourierModalComponent {
    constructor(httpClient, router, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.successColor = '';
        this.backColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.allCities = [];
        this.cities = [];
        this.city = 0;
        this.dropdownInFocus = false;
        this.cityError = false;
        this.errorColor = '';
        this.inputBackColor = '';
        this.placeholderText = '';
        this.initialValue = {};
        this.keyword = 'output';
        this.linkColor = '';
        document.documentElement.style.overflowY = 'hidden';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
        });
    }
    ngOnInit() {
        this.getCaravanCities();
        this.setDefalutValue();
    }
    setDefalutValue() {
        this.initialValue = { id: 0, name: '', output: '' };
    }
    close() {
        this.router.navigateByUrl('verify');
        this.modal.destroy();
    }
    setCity(item) {
        this.city = item;
    }
    onChangeSearchCity(val) {
        this.city = null;
    }
    onFocusedCity(e) {
        this.dropdownInFocus = e;
    }
    onPOClear(e) {
        this.city = null;
    }
    checkCity() {
        if (this.city == null || this.city === undefined) {
            this.cityError = true;
        }
        else {
            this.cityError = false;
        }
    }
    getCaravanCities() {
        this.httpClient.get('caravan/cities').subscribe((data) => {
            this.cities = data;
            let tmpPOs = this.cities;
            for (let i = 0; i < tmpPOs.length; i++) {
                tmpPOs[i].output = tmpPOs[i].name;
                if (this.data.cityId == tmpPOs[i].id) {
                    this.initialValue = tmpPOs[i];
                }
            }
            this.allCities = tmpPOs;
        }, (error) => {
            this.cities = [{ id: 0, name: '' }];
        });
    }
    submit() {
        if (this.city == null || this.city === undefined) {
            this.cityError = true;
            return;
        }
        else {
            this.cityError = false;
        }
        this.httpClient.post('user/setpersonalverificationmethod', {
            verification_method_code: 'courier',
            city: this.city.name
        }).subscribe((data) => {
            this.success();
            this.closeModal();
        });
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
};
VerifyCourierModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
VerifyCourierModalComponent = __decorate([
    Component({
        selector: 'ecd-verify-courier-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./verify-courier-modal.component.html")).default
    })
], VerifyCourierModalComponent);
export { VerifyCourierModalComponent };
